import { render, staticRenderFns } from "./LongTermGoals.vue?vue&type=template&id=756f66b7&scoped=true"
import script from "./LongTermGoals.vue?vue&type=script&lang=js"
export * from "./LongTermGoals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756f66b7",
  null
  
)

export default component.exports